"use client";

import * as React from "react";
import { getStoredTheme } from "@/lib/theme";

/**
 * Ép giao diện SÁNG cho trang chủ, bất kể theme toàn cục đang là gì.
 * Xử lý trường hợp điều hướng client-side vào trang chủ (script trong <head>
 * chỉ chạy khi tải trang đầy đủ). Khi rời trang chủ, khôi phục lại theme mà
 * người dùng đã chọn để các trang khác vẫn tôn trọng lựa chọn dark/light.
 */
export function ForceLightTheme() {
  React.useEffect(() => {
    const el = document.documentElement;
    el.setAttribute("data-theme", "light");
    return () => {
      const stored = getStoredTheme();
      const restored =
        stored ??
        (window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light");
      el.setAttribute("data-theme", restored);
    };
  }, []);

  return null;
}
